import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  header: {
    margin: "15px 0",
  },
  title: {
    fontSize: "14px",
    fontFamily: "Manrope",
    fontWeight: 600,
    lineHeight: "24px",
    marginRight: "15px",
  },
  iconEditButton: {
    marginTop: "17px !important",
    cursor: "pointer",
    width: "25px",
    height: "25px",
  },
  iconAddButton: {
    marginTop: "35px !important",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
  iconRemoveButton: {
    marginTop: "20px !important",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
  loading: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    background: "rgba(0, 0, 0, 0.2)",
  },
  iconDeleteButton: {
    width: "20px",
    height: "20px",
  },
  copyButton: {
    width: "220px",
  },
}));

export default styles;
